<div class="content-margin">
  <h1 class="ewrs-page-title">
    EWRS does not support Internet Explorer. Please use a modern browser like Edge v79 or greater, Chrome or Firefox
  </h1>
</div>
